import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Product.css";

import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import {
  Row,
  Col,
  Form,
  Modal,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../../utils/context";
import JoditEditor from "jodit-react";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddOffCanvance = (props) => {
  const {
    postData,
    getData,
    Select2Data,
    getDimension,
    SelectUsers,
    usertype,
  } = useContext(Context);

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [seller, setSellers] = useState([]);
  const [brands, setBrands] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [taxPercentages, setPercentages] = useState([]);
  const [attributes, setAttribute] = useState([]);
  const [subAttributes, setSubAttribute] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const editorConfig = {
    uploader: {
      insertImageAsBase64URI: true, // OR use server endpoint below
      // For server uploads:
      // url: '/api/upload-image', // Your upload endpoint
      allowedExtensions: ["jpg", "jpeg", "png", "gif"],
    },
    buttons: [
      "bold",
      "italic",
      "underline",
      "|",
      "ul",
      "ol",
      "|",
      "image",
      "link",
      "|",
      "align",
      "undo",
      "redo",
    ],
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
  };

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();

      DataToSend.append("name", data?.name);

      DataToSend.append("hsn_code", data?.hsn_code);
      DataToSend.append("delivery_charges", data?.delivery_charges);

      if (data?.about) {
        DataToSend.append("about", data?.about);
      }
      if (data?.benifits) {
        DataToSend.append("benifits", data?.benifits);
      }

      DataToSend.append("image1", data?.image1[0]);
      DataToSend.append("category_id", data?.category_id?.value);
      DataToSend.append("sub_category_id", data?.sub_category_id?.value);

      DataToSend.append("type", data?.type?.value);

      const main_m_variants = [];

      data.main_m_variants.forEach((mainVariant, mainIndex) => {
        const m_variants = [];

        mainVariant.m_variants.forEach((variant, variantIndex) => {
          const variantData = {
            varient_sub_name: variant?.varient_sub_name,
            unit: variant?.unit,
            mrp: variant?.mrp,
            s_price: variant?.s_price,
            cgst: variant?.cgst,
            sgst: variant?.sgst,
            igst: variant?.igst,
            cutting_price: variant?.cutting_price,
            images: [],
          };

          for (let i = 0; variant?.image[i]; i++) {
            DataToSend.append(
              `images${mainIndex}${variantIndex}${i}`,
              variant?.image[i]
            );
            variantData.images.push(variant?.image[i]?.name);
          }

          m_variants.push(variantData);
        });

        const mainVariantData = {
          varient_name: mainVariant.varient_name,
          m_variants: m_variants,
        };

        main_m_variants.push(mainVariantData);
      });

      DataToSend.append("main_m_variants", JSON.stringify(main_m_variants));

      const response = await postData(`/product`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllCategory = async () => {
    const response = await getData("/allcategories");

    if (response?.success) {
      setCategories(await Select2Data(response?.data, "category_id"));
    }
  };

  const GetAllSubCategory = async (id) => {
    const response = await getData(`/allsubcategories/${id}`);

    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "sub_category_id"));
    }
  };

  const GetAllChildSubCategory = async () => {
    const response = await getData(`/get-all-Sellers`);

    if (response?.success) {
      setSellers(await SelectUsers(response?.data, "user_id"));
    }
  };

  const GetAllBrands = async () => {
    const response = await getData("/allbrands");

    if (response?.success) {
      setBrands(await Select2Data(response?.data, "brand_id"));
    }
  };

  const GetAllTaxTypes = async () => {
    const response = await getData("/all-tax-type");

    if (response?.success) {
      setTaxTypes(await Select2Data(response?.data, "tax_type_id"));
    }
  };

  const GetAllTaxPercentages = async (id) => {
    const response = await getData(`/all-tax-percentage/${id}`);

    if (response?.success) {
      setPercentages(await Select2Data(response?.data, "tax_percentage_id"));
    }
  };

  const GetAllAttributes = async () => {
    const response = await getData(`/all-attribute`);

    if (response?.success) {
      setAttribute(await Select2Data(response?.data, "attribute_id"));
    }
  };

  const GetAllSubAttributes = async (id) => {
    const response = await getData(`/all-sub-attribute/${id}`);

    if (response?.success) {
      setSubAttribute(await Select2Data(response?.data, "sub_attribute_id"));
    }
  };

  useEffect(() => {
    GetAllChildSubCategory();
    GetAllCategory();
    GetAllBrands();
    GetAllTaxTypes();
    GetAllAttributes();
  }, []);

  const type = [
    {
      value: "Single",
      label: "Single",
    },
    // {
    //   value: "Multiple",
    //   label: "Multiple",
    // },
  ];

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    getValues,
    watch,
    setValue,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: {
      category_id: "",
      type: {
        value: "Single",
        label: "Single",
      },
      main_m_variants: [
        {
          varient_name: "",
          m_variants: [
            {
              varient_sub_name: "",
              unit: "",
              mrp: "",
              sku: "",
              s_price: "",
              images: [],
            },
          ],
        },
      ],
    },
  });

  const imageFile = watch("image1");
  const {
    fields: groupFields,
    append: appendGroup,
    remove: removeGroup,
  } = useFieldArray({
    control,
    name: "main_m_variants",
  });

  const handleAddGroup = () => {
    appendGroup({
      varient_name: "",
      m_variants: [
        {
          varient_sub_name: "",
          unit: "",
          mrp: "",
          sku: "",
          s_price: "",
          images: [],
        },
      ],
    });
  };

  const handleImagePreview = (event, groupIndex, itemIndex) => {
    const files = Array.from(event.target.files);
    const fileURLs = files.map((file) => URL.createObjectURL(file));
    setImagePreviews((prevPreviews) => {
      const newPreviews = [...prevPreviews];
      newPreviews[groupIndex] = newPreviews[groupIndex] || [];
      newPreviews[groupIndex][itemIndex] = fileURLs;
      return newPreviews;
    });
  };

  return (
    <>
      <div className="prodcuttttt">
        <Offcanvas
          show={props.show}
          style={{ width: "80%" }}
          placement={"end"}
          onHide={props.handleClose}>
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Add Employee</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>Add Product</Card.Title>
                <hr />
                <Container>
                  <Form>
                    <Row>
                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Row className="row justify-content-center mb-2">
                            <Form.Label>Category</Form.Label>
                            <Controller
                              name="category_id"
                              {...register("category_id", {
                                required: "Select Category",
                              })}
                              control={control}
                              render={({ field }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors.category_id
                                        ? "red"
                                        : baseStyles,
                                    }),
                                  }}
                                  {...field}
                                  options={categories}
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption.value);
                                    GetAllSubCategory(selectedOption.value);
                                    setValue("category_id", selectedOption);
                                    setValue("sub_category_id", "");
                                    setValue("child_sub_category_id", "");
                                    clearErrors("category_id");
                                  }}
                                />
                              )}
                            />
                            {errors.category_id && (
                              <span className="text-danger">
                                {errors.category_id.message}
                              </span>
                            )}
                          </Row>
                        </div>
                      </Col>
                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Row className="row justify-content-center mb-2">
                            <Form.Label>Sub Category</Form.Label>
                            <Controller
                              name="sub_category_id"
                              {...register("sub_category_id", {
                                required: "Select Sub Category",
                              })}
                              control={control}
                              render={({ field }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors.sub_category_id
                                        ? "red"
                                        : baseStyles,
                                    }),
                                  }}
                                  {...field}
                                  options={subCategories}
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption.value);
                                    GetAllChildSubCategory(
                                      selectedOption.value
                                    );
                                    setValue("sub_category_id", selectedOption);
                                    setValue("child_sub_category_id", "");
                                    clearErrors("sub_category_id");
                                  }}
                                />
                              )}
                            />
                            {errors.sub_category_id && (
                              <span className="text-danger">
                                {errors.sub_category_id.message}
                              </span>
                            )}
                          </Row>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Name</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="name"
                                  placeholder="Name .."
                                  className={classNames("", {
                                    "is-invalid": errors?.name,
                                  })}
                                  {...register("name", {
                                    required: "Name is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.name && (
                                <span className="text-danger">
                                  {errors.name.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Form.Label>Image</Form.Label>

                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.image1,
                              })}
                              type="file"
                              {...register("image1", {
                                required: "images is required",
                              })}
                              accept="image/*"
                            />
                          </Form.Group>
                          {errors.image1 && (
                            <span className="text-danger">
                              {errors.image1.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Form.Label>Image</Form.Label>
                          {imageFile && imageFile?.length > 0 && (
                            <div className="image-preview-container">
                              <img
                                src={URL?.createObjectURL(imageFile[0])}
                                alt="Preview"
                                className="image-preview"
                                style={{ width: "100px", height: "100px" }}
                              />
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col lg={3} md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="row justify-content-center mb-2">
                            <Form.Label>Varient Type</Form.Label>
                            <Controller
                              name="type"
                              control={control}
                              defaultValue={{
                                label: "Single",
                                value: "Single",
                              }} // <- Default value
                              rules={{ required: "Select Varient Type" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={type}
                                  isDisabled={true} // <- Disable the select
                                  value={field.value}
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption);
                                    setValue("type", selectedOption); // Keep object structure
                                  }}
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors.type
                                        ? "red"
                                        : baseStyles.borderColor,
                                    }),
                                  }}
                                />
                              )}
                            />
                            {errors.type && (
                              <span className="text-danger">
                                {errors.type.message}
                              </span>
                            )}
                          </Row>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>HSN Code</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="hsn_code"
                                  placeholder="HSN Code"
                                  maxLength={40}
                                  className={classNames("", {
                                    "is-invalid": errors?.hsn_code,
                                  })}
                                  {...register("hsn_code", {
                                    required: "HSN Code is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.hsn_code && (
                                <span className="text-danger">
                                  {errors.hsn_code.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Delivery Charges</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="delivery_charges"
                                  placeholder="Delivery Charges"
                                  maxLength={40}
                                  className={classNames("", {
                                    "is-invalid": errors?.delivery_charges,
                                  })}
                                  {...register("delivery_charges", {
                                    required: "Delivery Charges is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.delivery_charges && (
                                <span className="text-danger">
                                  {errors.delivery_charges.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <div className="main-form-section mt-5"></div>
                      <Card.Title>Product Details</Card.Title>
                      <hr />

                      <Col lg={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">
                            {" "}
                            {/* Align to left */}
                            {/* Description */}
                            <Col sm={12}>
                              <Form.Label className="text-center">
                                About
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="about"
                                  control={control}
                                  rules={{ required: "About is Required" }}
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={field.value}
                                      onChange={(newContent) =>
                                        field.onChange(newContent)
                                      }
                                      onBlur={field.onBlur}
                                      className={classNames("", {
                                        "is-invalid": !!errors.about,
                                      })}
                                      placeholder="About"
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.about && (
                                <span className="text-danger">
                                  {errors.about.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">
                            {" "}
                            {/* Align to left */}
                            {/* Description */}
                            <Col sm={12}>
                              <Form.Label className="text-center">
                                Size Chart
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="benifits"
                                  control={control}
                                  rules={{ required: "Size Chart is Required" }}
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={field.value}
                                      config={editorConfig}
                                      onChange={(newContent) =>
                                        field.onChange(newContent)
                                      }
                                      onBlur={field.onBlur}
                                      className={classNames("", {
                                        "is-invalid": !!errors.benifits,
                                      })}
                                      placeholder="About"
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.benifits && (
                                <span className="text-danger">
                                  {errors.benifits.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <div className="main-form-section mt-5"></div>
                      <Card.Title>
                        Product Size Details
                        {/* {variantsError && (
                          <div className="text-danger">{variantsError}</div>
                        )} */}
                      </Card.Title>
                      <hr />
                      {groupFields.map((variant, groupIndex) => (
                        <>
                          <div
                            key={groupIndex}
                            className="main-form-section mt-3">
                            <Row>
                              {getValues("type")?.value == "Single" ? (
                                ""
                              ) : (
                                <Col md={3}>
                                  <div className="main-form-section mt-3">
                                    <Row className="justify-content-center">
                                      <Form.Label>Variant Name</Form.Label>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name={`main_m_variants.${groupIndex}.varient_name`}
                                            placeholder="Variant Name"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.main_m_variants?.[
                                                  groupIndex
                                                ]?.varient_name,
                                            })}
                                            {...register(
                                              `main_m_variants.${groupIndex}.varient_name`,
                                              {
                                                required:
                                                  "Variant name is required",
                                              }
                                            )}
                                          />
                                        </InputGroup>
                                        {errors?.main_m_variants?.[groupIndex]
                                          ?.varient_name && (
                                          <span className="text-danger">
                                            {
                                              errors.main_m_variants[groupIndex]
                                                .varient_name.message
                                            }
                                          </span>
                                        )}
                                      </Form.Group>
                                    </Row>
                                  </div>
                                </Col>
                              )}
                              <FieldArray
                                control={control}
                                groupIndex={groupIndex}
                                register={register}
                                errors={errors}
                                getValues={getValues}
                                watch={watch}
                                setValue={setValue}
                                imagePreviews={imagePreviews}
                                setImagePreviews={setImagePreviews}
                                handleImagePreview={handleImagePreview}
                                clearErrors={clearErrors}
                              />

                              {/* {getValues("type")?.value == "Single" ? (
                                ""
                              ) : (
                                <Col md={3}>
                                  <button
                                    type="button"
                                    className="mt-3 add-varient"
                                    onClick={() => removeGroup(groupIndex)}>
                                    Remove Group
                                  </button>
                                </Col>
                              )} */}
                            </Row>
                          </div>
                        </>
                      ))}
                      {/* {getValues("type")?.value == "Single" ? (
                        ""
                      ) : (
                        <button
                          type="button"
                          className="mt-3 add-varient"
                          onClick={() => handleAddGroup()}>
                          Add Group
                        </button>
                      )} */}
                    </Row>
                    <Row className="mt-5 pb-3">
                      <div className="d-flex justify-content-center">
                        <Link>
                          <CancelButton
                            name={"cancel"}
                            handleClose={props.handleClose}
                          />
                        </Link>

                        <Button
                          name={"save"}
                          onClick={handleSubmit(onSubmit)}
                          type="button"
                          className="save-btnnnnnn">
                          <FontAwesomeIcon
                            icon="fa-solid fa-floppy-disk"
                            className="me-2"
                          />
                          save
                        </Button>
                      </div>
                    </Row>
                  </Form>
                </Container>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
        </Offcanvas>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </div>
    </>
  );
};

const FieldArray = ({
  control,
  groupIndex,
  register,
  errors,
  getValues,
  setValue,
  watch,
  setImagePreviews,
  imagePreviews,
  handleImagePreview,
  clearErrors,
}) => {
  const {
    fields: itemFields,
    append: appendItem,
    remove: removeItem,
  } = useFieldArray({
    control,
    name: `main_m_variants.${groupIndex}.m_variants`,
  });

  const handleAddItem = () => {
    appendItem({ value: "" });
  };

  const handleMRPChange = (itemIndex, newMRP) => {
    const cgst = parseFloat(
      getValues(`main_m_variants.${groupIndex}.m_variants.${itemIndex}.cgst`) ||
        0
    );

    const sgst = parseFloat(
      getValues(`main_m_variants.${groupIndex}.m_variants.${itemIndex}.sgst`) ||
        0
    );

    // Calculate the scheme price as MRP - Scheme Percent
    const CgstPrice = newMRP / (1 + (cgst + sgst) / 100);
    const schemePrice = newMRP - newMRP * (sgst / 100);
    const sellingPrice = CgstPrice;

    // Update the scheme price and selling price in the form

    setValue(
      `main_m_variants.${groupIndex}.m_variants.${itemIndex}.cgst_price`,
      CgstPrice.toFixed(2)
    );

    setValue(
      `main_m_variants.${groupIndex}.m_variants.${itemIndex}.sgst_price`,
      schemePrice.toFixed(2)
    );

    setValue(
      `main_m_variants.${groupIndex}.m_variants.${itemIndex}.s_price`,
      sellingPrice.toFixed(2)
    );
  };

  const handleIGSTChange = (itemIndex) => {
    const cgst = parseFloat(
      getValues(`main_m_variants.${groupIndex}.m_variants.${itemIndex}.cgst`) ||
        0
    );
    const sgst = parseFloat(
      getValues(`main_m_variants.${groupIndex}.m_variants.${itemIndex}.sgst`) ||
        0
    );
    const igst = cgst + sgst;
    setValue(
      `main_m_variants.${groupIndex}.m_variants.${itemIndex}.igst`,
      igst.toFixed(2)
    );
  };

  // Watch the fields
  const watchItems = watch(
    `main_m_variants.${groupIndex}.m_variants`,
    itemFields
  );

  useEffect(() => {
    watchItems.forEach((item, itemIndex) => {
      const mrp = parseFloat(item.mrp || 0);
      handleMRPChange(itemIndex, mrp);
      handleIGSTChange(itemIndex);
    });
  }, [watchItems, groupIndex, setValue]);

  return (
    <>
      {itemFields.map((item, itemIndex) => (
        <div key={item.id} className="main-form-section mt-3">
          <Row>
            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>
                    {" "}
                    {getValues("type")?.value == "Single" ? "" : "Sub"}
                    Name
                  </Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name={`main_m_variants.${groupIndex}.m_variants.${itemIndex}.varient_sub_name`}
                        placeholder={
                          (getValues("type")?.value == "Single" ? "" : "Sub ") +
                          "Size Name"
                        }
                        className={classNames("", {
                          "is-invalid":
                            errors.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.varient_sub_name,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.varient_sub_name`,
                          {
                            required: "Sub Variant name is required",
                          }
                        )}
                      />
                    </InputGroup>
                    {errors.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.varient_sub_name && (
                      <span className="text-danger">
                        {
                          errors.variants?.[groupIndex]?.m_variants?.[itemIndex]
                            ?.varient_sub_name?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>
                    {" "}
                    {getValues("type")?.value == "Single" ? "" : "Sub"} Units
                  </Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name={`main_m_variants.${groupIndex}.m_variants.${itemIndex}.unit`}
                        placeholder={
                          (getValues("type")?.value == "Single" ? "" : "Sub ") +
                          "Unit"
                        }
                        className={classNames("", {
                          "is-invalid":
                            errors.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.unit,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.unit`,
                          {
                            required: "unit is required",
                          }
                        )}
                      />
                    </InputGroup>
                    {errors.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.unit && (
                      <span className="text-danger">
                        {
                          errors.variants?.[groupIndex]?.m_variants?.[itemIndex]
                            ?.unit?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Cut Price</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Cut Price"
                        className={classNames("", {
                          "is-invalid":
                            errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.cutting_price,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.cutting_price`,
                          {
                            required: "Cut Price is required",
                            validate: (value) =>
                              value >= 0 || "Cut Price cannot be negative",
                            // onChange: (e) => {
                            //   const newMRP = parseFloat(e.target.value || 0);
                            //   handleMRPChange(itemIndex, newMRP);
                            // },
                          }
                        )}
                      />
                    </InputGroup>
                    {errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.cutting_price && (
                      <span className="text-danger">
                        {
                          errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                            itemIndex
                          ]?.cutting_price?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>MRP</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="MRP"
                        className={classNames("", {
                          "is-invalid":
                            errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.mrp,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.mrp`,
                          {
                            required: "MRP is required",
                            validate: (value) =>
                              value >= 0 || "MRP cannot be negative",
                            onChange: (e) => {
                              const newMRP = parseFloat(e.target.value || 0);
                              handleMRPChange(itemIndex, newMRP);
                            },
                          }
                        )}
                      />
                    </InputGroup>
                    {errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.mrp && (
                      <span className="text-danger">
                        {
                          errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                            itemIndex
                          ]?.mrp?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>CGST Percent</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="CGST Percent"
                        max={100}
                        className={classNames("", {
                          "is-invalid":
                            errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.cgst,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.cgst`,
                          {
                            required: "cgst Percent is required",

                            validate: {
                              minValue: (value) =>
                                value > 0 || "cgst Percent cannot be Negative",
                              maxValue: (value) =>
                                value <= 100 ||
                                "cgst Percent cannot exceed 100",
                            },

                            onChange: (e) => {
                              const newScheme = parseFloat(e.target.value || 0);
                              const mrp = parseFloat(
                                getValues(
                                  `main_m_variants.${groupIndex}.m_variants.${itemIndex}.mrp`
                                )
                              );
                              handleMRPChange(itemIndex, mrp);
                              handleIGSTChange(itemIndex);
                            },
                          }
                        )}
                      />
                    </InputGroup>
                    {errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.cgst && (
                      <span className="text-danger">
                        {
                          errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                            itemIndex
                          ]?.cgst?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>SGST Percent</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="SGST Percent"
                        max={100}
                        className={classNames("", {
                          "is-invalid":
                            errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.sgst,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.sgst`,
                          {
                            required: "sgst Percent is required",
                            validate: (value) =>
                              value >= 0 || "sgst Percent cannot be negative",
                            validate: {
                              minValue: (value) =>
                                value >= 0 || "sgst Percent cannot be Negative",
                              maxValue: (value) =>
                                value <= 100 ||
                                "sgst Percent cannot exceed 100",
                            },
                            onChange: (e) => {
                              const newsgst = parseFloat(e.target.value || 0);
                              const mrp = parseFloat(
                                getValues(
                                  `main_m_variants.${groupIndex}.m_variants.${itemIndex}.mrp`
                                ) || 0
                              );
                              handleMRPChange(itemIndex, mrp);
                              handleIGSTChange(itemIndex);
                            },
                          }
                        )}
                      />
                    </InputGroup>
                    {errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.sgst && (
                      <span className="text-danger">
                        {
                          errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                            itemIndex
                          ]?.sgst?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>IGST</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="IGST Percent"
                        max={100}
                        className={classNames("", {
                          "is-invalid":
                            errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.igst,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.igst`,
                          {
                            required: "igst Percent is required",
                            validate: (value) =>
                              value >= 0 || "igst Percent cannot be negative",
                            validate: {
                              minValue: (value) =>
                                value >= 0 || "igst Percent cannot be Negative",
                              maxValue: (value) =>
                                value <= 100 ||
                                "igst Percent cannot exceed 100",
                            },
                          }
                        )}
                        disabled
                      />
                    </InputGroup>
                    {errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.igst && (
                      <span className="text-danger">
                        {
                          errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                            itemIndex
                          ]?.igst?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col md={3}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Basic Price</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        name={`main_m_variants.${groupIndex}.m_variants.${itemIndex}.s_price`}
                        placeholder="Basic Price"
                        className={classNames("", {
                          "is-invalid":
                            errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                              itemIndex
                            ]?.s_price,
                        })}
                        {...register(
                          `main_m_variants.${groupIndex}.m_variants.${itemIndex}.s_price`,
                          {
                            // required: "MRP is required",
                            validate: (value) => {
                              if (!value) return "MRP is required";
                              const minimumOrderValue = parseFloat(
                                getValues(
                                  `main_m_variants.${groupIndex}.m_variants.${itemIndex}.mrp`
                                )
                              );
                              // if (parseFloat(value) <= 0) {
                              //   return "MRP must be a positive number";
                              // }

                              // Check if discount is less than minimum order value
                              // if (parseFloat(value) > minimumOrderValue) {
                              //   return "Selling Price must not be greater than MRP";
                              // }

                              return true; // Return true for valid input
                            },
                          }
                        )}
                        disabled
                      />
                    </InputGroup>
                    {errors.main_m_variants?.[groupIndex]?.m_variants?.[
                      itemIndex
                    ]?.s_price && (
                      <span className="text-danger">
                        {
                          errors.main_m_variants?.[groupIndex]?.m_variants?.[
                            itemIndex
                          ]?.s_price.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>

            <Col lg={3}>
              <div className="main-form-section mt-3">
                <Form.Label>Images</Form.Label>

                <Form.Group>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid":
                        errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                          itemIndex
                        ]?.image,
                    })}
                    type="file"
                    multiple
                    {...register(
                      `main_m_variants.${groupIndex}.m_variants.${itemIndex}.image`,
                      {
                        required: "Images are required",
                      }
                    )}
                    accept="image/*"
                    onChange={(e) => {
                      handleImagePreview(e, groupIndex, itemIndex);
                      clearErrors(
                        `main_m_variants.${groupIndex}.m_variants.${itemIndex}.image`
                      );
                    }}
                  />
                </Form.Group>

                {errors?.main_m_variants?.[groupIndex]?.m_variants?.[itemIndex]
                  ?.image && (
                  <span className="text-danger">
                    {
                      errors?.main_m_variants?.[groupIndex]?.m_variants?.[
                        itemIndex
                      ]?.image.message
                    }
                  </span>
                )}

                {/* Image Previews */}
                <div className="mt-2">
                  {imagePreviews[groupIndex] &&
                    imagePreviews[groupIndex][itemIndex] &&
                    imagePreviews[groupIndex][itemIndex].map(
                      (imageSrc, index) => (
                        <img
                          key={index}
                          src={imageSrc}
                          alt={`preview-${index}`}
                          style={{
                            width: "80px",
                            height: "80px",
                            margin: "5px",
                          }}
                        />
                      )
                    )}
                </div>
              </div>
            </Col>
            {/* <Col lg={3}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <button
                    type="button"
                    className="mt-3 add-varient"
                    onClick={() => removeItem(itemIndex)}>
                    Remove Item
                  </button>
                </Form.Group>
              </div>
            </Col> */}
            {/* <label>
            Item Value:
            <input
              {...register(
                `variants.${groupIndex}.m_variants.${itemIndex}.value`
              )}
            />
          </label> */}
          </Row>
        </div>
      ))}
      {/* <Col md={3}>
        <button
          type="button"
          className="mt-3 add-varient"
          onClick={handleAddItem}>
          Add Item
        </button>
      </Col> */}
    </>
  );
};

export default AddOffCanvance;
